import { render, staticRenderFns } from "./AlignCenterHIcon.vue?vue&type=template&id=37d3cfac&"
import script from "./AlignCenterHIcon.vue?vue&type=script&lang=js&"
export * from "./AlignCenterHIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports